// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2-tex","text":"SelectPayment_text__3M2oz","title":"SelectPayment_title__M3sC3","btn":"SelectPayment_btn__14FUI"};